import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
import LocalizedStrings from 'react-localization';

import { ClientLanguage } from "../../../../../Api"

// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/DocumentsStudents';
import { WorkingStudentDataSubForm, Schema as WorkingStudentDataSchema } from '../subforms/WorkingStudentData';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformationStudent';

let locStrings = new LocalizedStrings({
    de:
    {
        mandatoryFieldsHint: "Die im Folgenden mit * markierten Felder sind Pflichtfelder.",
    },
    en:
    {
        mandatoryFieldsHint: "The fields marked with * are mandatory.",
    }
});

export const DspaceWerkstudentSchema = (settings, clientLanguage) => (
    Yup.object()
        .concat(SalutationSchema(clientLanguage))
        .concat(NameAndContactSchema(settings, clientLanguage))
        .concat(DocumentsSchema(settings, clientLanguage))
        .concat(WorkingStudentDataSchema(settings, clientLanguage))
        .concat(OtherInformationSchema(clientLanguage))
);

export const DspaceWerkstudent = (props) => {
    const { colors, settings, clientLanguage } = props;

    setLanguage();

    function setLanguage(): void {
        switch(clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }
    
    return (
        <>
            <Form.Text muted>{locStrings.mandatoryFieldsHint}</Form.Text>
            <Field component={SalutationSubForm} colors={colors} clientLanguage={clientLanguage} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} clientLanguage={clientLanguage} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} clientLanguage={clientLanguage} />
            <Field component={WorkingStudentDataSubForm} colors={colors} settings={settings} clientLanguage={clientLanguage} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} clientLanguage={clientLanguage} />
        </>
    );
}